<!-- 
  -- Projet: Gestion des stagiaires
  -- Auteur : Tim Allemann
  -- Date : 23.09.2022
  -- Description : Formulaire de création d'une activité depuis la liste des activités
  -- Fichier : CreateIntershipActivityFromList.vue
  -->

<template>
  <v-row>
    <v-form ref="formCreateMoyen" v-model="validCreateMoyen" lazy-validation>
      <v-dialog v-model="dialog" max-width="600px">
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" class="mx-3" color="primary">
            Ajouter un type d'activité
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">Ajouter un type d'activité</span>
          </v-card-title>
          <v-card-text>
            <v-text-field
              v-model="typeIntershipActivity.nom"
              :counter="50"
              :rules="libelleRules"
              label="Nom"
              required
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialog = false">
              Fermer
            </v-btn>
            <v-btn color="blue darken-1" text @click="submit()">
              Sauvegarder
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
  </v-row>
</template>

<script>
import store from '@/store/index.js'
import NProgress from 'nprogress'

export default {
  data: () => ({
    validCreateMoyen: true,
    dialog: false,
    typeIntershipActivity: {
      typeIntershipActivityId: 0,
      nom: null
    },
    libelleRules: [
      v => !!v || 'Le champ est obligatoire',
      v => !v || v.length <= 50 || 'Le champ doit être moins que 50 caractères'
    ]
  }),

  methods: {
    // Si le formulaire est valide, création d'un moyen
    submit() {
      if (this.$refs.formCreateMoyen.validate()) {
        NProgress.start()
        store
          .dispatch(
            'typeIntershipActivity/createTypeIntershipActivity',
            this.typeIntershipActivity
          )
          .then(() => {
            this.$refs.formCreateMoyen.reset()
            this.dialog = false
          })
          .catch(() => {})

        NProgress.done()
      }
    }
  }
}
</script>
